import script from "./RadioBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./RadioBox.vue?vue&type=script&setup=true&lang=ts"

import "./RadioBox.vue?vue&type=style&index=0&id=341e15a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-341e15a6"]])

export default __exports__